import { createFileRoute } from '@tanstack/react-router';

import { AboutCompanyScreen } from '@/screens/onboarding/AboutCompanyScreen';

export const Route = createFileRoute('/_onboarding/onboarding/about-company')({
  component: AboutCompanyScreen,
});
